<template>
  <ym-row-button class="product-action-row-bar"
                 :type="type"
                 :hint="price.hint"
                 :price="price.value"
                 :del-price="deletePrice"
                 :size="size"
                 :round="round"
                 :desc="price.desc"
                 :disabled="price.disabled"
                 @click="handleClick"
  />
</template>

<script>
  import YmRowButton from '@/components/ProductDetailBottom/components/ActionRowBtn';

  export default {
    name: 'ProductDetailBottomActionRowBar',
    components: {
      YmRowButton,
    },
    props: {
      type: {
        type: String,
        default: 'primary',
      },
      price: {
        type: Object,
        required: true,
      },
      showDelete: {
        type: Boolean,
        default: true,
      },
      size: {
        type: String,
        default: 'normal',
        validator(val) {
          return [
            'small',
            'normal',
            'medium',
          ].includes(val);
        },
      },
      round: Boolean,
    },
    computed: {
      deletePrice() {
        return !this.showDelete ? 0 : this.price.delete;
      },
      routeName() {
        return this.$route.name;
      },
    },
    methods: {
      handleClick() {
        const {
          targetId,
          targetType,
          hint,
          disabled,
        } = this.price;
        if (disabled) return;

        this.$emit('click', {
          targetId,
          targetType,
          hint,
          page: this.routeName,
        });
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-action-row-bar {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>
